import { Box, Button, Grid2, Theme, SxProps } from "@mui/material";
import { AppTheme } from "../../theme";
import { Tag as TagType } from "../../types/freight/tag.type";
import { tagDefaultColor } from "../../constants/TagDefaultColor";
import { sortShipmentTags } from "../../utils/shipmentTags";
import { defaultMaxOverlappedItems } from "./tagsGridConstants";
import { Tag } from "./Tag";
import { Tooltip } from "./Tooltip";

type OverlappedTagsPopupProps = {
  tags: TagType[];
};

const OverlappedTagsPopup = ({ tags }: OverlappedTagsPopupProps) => (
  <Box sx={{ cursor: "pointer", marginLeft: "0.25rem" }}>
    <Tooltip
      content={
        <Box paddingBlock={0.5}>
          {tags
            .filter((tag) => tag.name)
            .map((tag) => (
              <Box key={tag.name} sx={{ display: "inline-block", margin: 0.5 }}>
                <Tag
                  color="white"
                  label={tag.name}
                  fontWeight={400}
                  backgroundColor={tag.colorHex || tagDefaultColor}
                  borderRadius={4}
                />
              </Box>
            ))}
        </Box>
      }
    >
      <Button
        aria-label="Show additional tags"
        sx={{
          minWidth: "unset",
          padding: 0,
          color: AppTheme.palette.primary.main,
          fontSize: "14px",
          fontFamily: "lato",
          fontWeight: 400,
          lineHeight: "24px",
        }}
      >
        +{tags.length}
      </Button>
    </Tooltip>
  </Box>
);

type TagsGridProps = {
  tags?: TagType[];
  maxOverlappedItems?: number;
  sx?: SxProps<Theme>;
};

export const TagsGrid = ({
  tags = [],
  maxOverlappedItems = defaultMaxOverlappedItems,
  sx,
}: TagsGridProps) => {
  const sortedTags = sortShipmentTags(tags);

  return (
    <Box sx={{ ...sx, overflowX: "hidden" }}>
      <Grid2
        sx={{
          display: "flex",
        }}
      >
        {sortedTags
          .slice(0, maxOverlappedItems)
          .filter((tag) => tag.name)
          .map((tag) => (
            <Box key={tag.name} paddingInlineEnd={0.5}>
              <Tag
                color="white"
                label={tag.name}
                backgroundColor={tag.colorHex || tagDefaultColor}
                borderRadius={4}
              />
            </Box>
          ))}
        {sortedTags.length > maxOverlappedItems && (
          <OverlappedTagsPopup
            tags={sortedTags.slice(maxOverlappedItems, sortedTags.length)}
          />
        )}
      </Grid2>
    </Box>
  );
};
